import { useState } from "react";
import styles from "../../styles/components/RestartChainModal.module.css";
import Button from "../../ui/buttons/Button";
import StatusFeedbackModal from "../settings/modals/StatusFeedbackModal";
import ModalOverlay from "../../ui/Modals/ModalOverlay";
import { mailsService } from "../../services/mails.service";

function formatLastSendDate(isoDate) {
  if (!isoDate) return "-";

  const date = new Date(isoDate);

  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function RestartChainModal({ notification, onClose }) {
  const payload = notification?.payload || {};
  const mailId = payload.mail_id ?? notification?.entity_id;

  const [restarting, setRestarting] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const confirmRestart = async () => {
    setRestarting(true);

    try {
      await mailsService.restartChain(mailId);

      setFeedback({
        status: "success",
        title: "Comunicación reiniciada",
        message: "La comunicación se reinició desde el primer template.",
      });
    } catch (error) {
      const backendError =
        error?.response?.status === 409 ? error?.response?.data?.error : null;

      setFeedback({
        status: "error",
        title: "No se pudo reiniciar la comunicación",
        message:
          backendError ||
          "Ocurrió un error al reiniciar la comunicación. Intentá nuevamente.",
      });
    } finally {
      setRestarting(false);
    }
  };

  if (feedback) {
    return (
      <StatusFeedbackModal
        isOpen
        status={feedback.status}
        title={feedback.title}
        message={feedback.message}
        onClose={onClose}
      />
    );
  }

  const detailRows = [
    { label: "Lead", value: payload.lead_name },
    { label: "Casilla", value: payload.mail_corp_email },
    { label: "Grupo de templates", value: payload.template_group_name },
    { label: "Último asunto enviado", value: payload.last_subject },
    { label: "Cantidad de envíos", value: payload.send_count },
    { label: "Último envío", value: formatLastSendDate(payload.last_send) },
  ];

  return (
    <ModalOverlay className={styles.overlay} onClose={restarting ? undefined : onClose}>
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="restart-chain-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className={styles.header}>
          <h3 id="restart-chain-modal-title" className={styles.title}>
            Fin de la cadena de emails
          </h3>
        </div>

        <div className={styles.body}>
          <p className={styles.question}>
            {notification?.message ||
              "Se envió el último email de la cadena. ¿Desea reiniciar la comunicación?"}
          </p>

          <dl className={styles.details}>
            {detailRows.map(({ label, value }) => (
              <div key={label} className={styles.detailRow}>
                <dt className={styles.detailLabel}>{label}</dt>
                <dd className={styles.detailValue}>{value ?? "-"}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className={styles.footer}>
          <Button
            variant="secondary"
            tone="blue"
            onClick={onClose}
            disabled={restarting}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            tone="blue"
            onClick={confirmRestart}
            loading={restarting}
            disabled={!mailId}
          >
            Reiniciar comunicación
          </Button>
        </div>
      </div>
    </ModalOverlay>
  );
}

export default RestartChainModal;
